import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import NavBar from '../../components/NavBarSearchSong';
import { Grid } from '@material-ui/core';
import { SvgList } from '../../components';
import search from '../../assets/ic_search.png';
import { useHistory } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Settings from '../../assets/Settings.png';
import { formatDateToDisplay } from '../../utils';
import { reviewSongsServices } from '../../services';
import PlayListThumbnail from '../../components/PlayListThumbnail';
import SearchBox from '../../components/SearchBox';

function ReviewSong() {
  const LIMIT = 50;
  const history = useHistory();
  const [reviewSongs, setReviewSongs] = useState([]);
  const [isFetchingMore, setisFetchingMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const [rowsData, setRowsData] = useState();

  console.log(rowsData, 'rowsData');

  useEffect(() => {
    // Fetch First 10 Songs
    const fetchAllReviewSongs = async () => {
      setIsLoading(true);
      const response = await reviewSongsServices.fetchAllReviewsongs({
        page: currentPage.page,
        limit: LIMIT,
        search: '',
        submission_status: 'PENDING',
        status: 'ACTIVE',
        created_by: ['ARTIST'],
      });

      if (response?.data?.data?.length > 0) {
        setReviewSongs([...reviewSongs, ...response?.data?.data]);
        setIsLoading(false);
        setisFetchingMore(false);
      }

      if (response?.data?.data?.length < LIMIT) {
        setisFetchingMore(false);
        setIsLoading(false);
        setCurrentPage({ ...currentPage, isLast: true });
      }
    };
    fetchAllReviewSongs();
  }, [currentPage.page]);

  useEffect(() => {
    const reviewSongsData = reviewSongs.map((row, i) => ({
      id: row.id,
      title: row.title,
      reviewplaylistImg: row.thumbnail_img || '',
      result: i + 1,
      dateadded: formatDateToDisplay(row.created_at),
      artist_name: row.artist_name,
      status: row.status,
      creator_id: row.creator_id,
    }));
    setRowsData(reviewSongsData);
  }, [reviewSongs]);

  // Detect When user scroll to bottom of table
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !currentPage.isLast) {
      setisFetchingMore(true);
      setCurrentPage({ ...currentPage, page: currentPage.page + 1 });
    }
  };

  const handleSearchInputChange = (searchVal) => {
    const InitialPlaylistData = reviewSongs.map((row, i) => ({
      id: row.id,
      title: row.title,
      reviewplaylistImg: row.thumbnail_img || '',
      result: i + 1,
      dateadded: formatDateToDisplay(row.created_at),
      artist_name: row.artist_name,
      status: row.status,
    }));

    if (searchVal !== '') {
      (async () => {
        const reviewSongs = await reviewSongsServices.fetchAllReviewsongs({
          page: 1,
          limit: LIMIT,
          search: searchVal,
          submission_status: 'PENDING',
          status: 'ACTIVE',
          created_by: ['ARTIST'],
        });
        const searchResponseData = reviewSongs?.data?.data?.map((row, i) => ({
          id: row.id,
          title: row.title,
          reviewplaylistImg: row.thumbnail_img || '',
          result: i + 1,
          dateadded: formatDateToDisplay(row.created_at),
          artist_name: row.artist_name,
          status: row.status,
        }));

        setRowsData(searchResponseData);
      })();
    } else {
      setRowsData(InitialPlaylistData);
    }
  };

  return (
    <>
      <NavBar
        data="Review Song"
        icon={Settings}
        currentRouteName="Review Song"
        breadcrumbsPath={[{ name: 'Songs', link: '/songs/search-songs' }]}
      />
      <div className="content" style={{ marginTop: 73 }}>
        <div style={{ marginBottom: 12 }}>
          <SearchBox placeholder="Search song here..." onChange={(e) => handleSearchInputChange(e)} />
        </div>

        <div style={{ display: 'flex', width: '100%', height: '100%', overflow: 'hidden', flex: 1 }}>
          <TableContainer className="tbl_wraper tbl_wrap" component={Paper} onScroll={handleScroll}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="table_font result-with-image">Result</TableCell>
                  <TableCell className="song">Song Name</TableCell>
                  <TableCell>Artist</TableCell>
                  <TableCell className="dateadded">Date Added</TableCell>
                  <TableCell className="status">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <div className="table_initial_loader">
                    <CircularProgress />
                  </div>
                )}
                {rowsData?.length === 0 && !isLoading ? (
                  <div className="table_initial_loader">
                    <h4
                      style={{
                        textAlign: 'center',
                        marginBottom: 20,
                        fontSize: 20,
                        lineHeight: '32px',
                        maxWidth: '60%',
                        marginInline: 'auto',
                      }}
                    >
                      No Songs Found
                    </h4>
                  </div>
                ) : (
                  rowsData?.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell width={240} className="result-with-image">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span>#{index + 1}</span>
                          <PlayListThumbnail src={row.reviewplaylistImg} name={row.title} style={{ borderRadius: 6 }} />
                        </div>
                      </TableCell>
                      <TableCell className="song">{row.title}</TableCell>
                      <TableCell>{row.artist_name}</TableCell>
                      <TableCell className="dateadded">{row.dateadded}</TableCell>
                      <TableCell
                        className="status"
                        style={{ cursor: 'pointer' }}
                        onClick={() => history.push(`/artists/${row.creator_id}?active=uploaded_music`)}
                      >
                        <SvgList name="copylink-icon" />
                      </TableCell>
                    </TableRow>
                  ))
                )}

                {isFetchingMore && (
                  <TableRow className="fetch_more_loader">
                    <CircularProgress />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
}
export default ReviewSong;

